/*
*
* Formations
*
*/

import React from 'react';
import { connect } from 'react-redux';
import { setTitle, setLoader, setBreadcrumb, delayedDispatch, updateCrumb } from 'store/actions';
import { Table } from 'components';
import { Helmet } from 'react-helmet';
import { push } from 'connected-react-router';
import Strings from 'utils/strings';
import { API, Endpoints } from "utils/api";
import { toast } from 'utils/utils';
import './styles.scss';

export class Formations extends React.Component<any, any> {
	constructor(props: any) {
		super(props);

		this.state = {
			windowWidth: window.innerWidth < 900 ? window.innerWidth - 20 : 900,
			tempTraining: {},
			language: 'pt',
		};
	}

	componentDidMount() {
		const { dispatch } = this.props;

		// change this
		dispatch(setTitle(Strings.sidebar.formations));

		delayedDispatch(
			setBreadcrumb(() => {
				return {
					locations: [
						{
						  text: Strings.sidebar.formations,
						//   route: "/formations",
						  icon: "working-briefcase",
						},
					],
				}
			})
		);

		this.getFormations();
	}

	componentDidUpdate() {
		const { dispatch } = this.props;
	
		dispatch(updateCrumb());
	}

	async getFormations() {
		const response = await API.get({
			url: Endpoints.uriFormations(),
		});
	  
		if (response.ok) {
			this.setState({ formations: response.data.results });
		} else {
			return toast.error(response.data?.message || Strings.serverErrors.title);
		}
	}

	async deleteFormation(id : any) {
		const { dispatch } = this.props;

		dispatch(setLoader(false));

		const response = await API.delete({
			url: Endpoints.uriFormations(id),
		});

		if (response.ok) {
			this.setState({ formations: response.data.results });
		} else {
			dispatch(setLoader(false));
			return toast.error(response.data?.message || Strings.serverErrors.title);
		}

		dispatch(setLoader(false));
	}

	render() {
		const { formations = [], language } = this.state;
		const { dispatch } = this.props;

		return (
			<React.Fragment>
				<Helmet>
					<title>{Strings.sidebar.formations}</title>
					<meta name="description" content="Description of Formations" />
				</Helmet>
				<Table
					title={{
						icon: "working-briefcase",
						title: Strings.sidebar.formations
					}}
					data={formations}
					columns={[
						{
							Header: Strings.formation.header,
							id: 'name',
							accessor: (row: any) => row.name?.[language],
						},
					]}
					filterable
					add={{
						label: String(Strings.formatString(Strings.generic.addNew, Strings.formation.header.toLowerCase())),
						onClick: () => dispatch(push('/formations/new')),
					}}
					actions={{
						edit: (original, value) => ({
							onClick: (row: any) => dispatch(push(`/formations/${original._id}`)),
						}),
						remove: (original, value) => ({
							onClick: () => this.deleteFormation(original._id),
						}),
					}}
				/>
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state: any) => ({});

export default connect(mapStateToProps)(Formations);